/* The Neon Lady - flicker-on headings and the cycling demo sign. */
(function () {
  if (window.tnlNeon) return;
  window.tnlNeon = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function light(el) {
    if (el.dataset.tnlReady) return;
    el.dataset.tnlReady = '1';
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-lit'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { el.classList.add('is-lit'); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(el);
  }

  function sign(el) {
    if (el.dataset.tnlReady) return;
    el.dataset.tnlReady = '1';
    var words = [];
    try { words = JSON.parse(el.dataset.words || '[]'); } catch (e) {}
    words = words.map(function (w) { return String(w).trim(); }).filter(Boolean);
    var colours = [['#ff2d95', 'Hot pink'], ['#3fd0ff', 'Ice blue'], ['#ffcf8a', 'Warm white'], ['#39ff88', 'Green'], ['#b26bff', 'Purple'], ['#ff3b30', 'Red']];
    var text = el.querySelector('.tnl-sign__text');
    var chip = el.querySelector('.tnl-sign__chip');
    var i = 0;
    function fit() {
      if (!text) return;
      text.style.fontSize = '';
      var room = el.clientWidth * 0.68;
      var width = text.scrollWidth;
      if (width > room) text.style.fontSize = (parseFloat(window.getComputedStyle(text).fontSize) * room / width) + 'px';
    }
    function paint() {
      var c = colours[i % colours.length];
      el.style.setProperty('--c', c[0]);
      if (chip) chip.textContent = c[1];
      fit();
    }
    paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(fit, 150); });
    if (reduce || words.length < 2 || !text) return;
    setInterval(function () {
      if (document.hidden) return;
      el.classList.add('is-off');
      setTimeout(function () {
        i = (i + 1) % words.length;
        text.textContent = words[i];
        paint();
        el.classList.remove('is-off', 'is-flicker');
        void el.offsetWidth;
        el.classList.add('is-flicker');
      }, 420);
    }, 2800);
  }

  function init(root) {
    root.querySelectorAll('[data-tnl-light]').forEach(light);
    root.querySelectorAll('[data-tnl-sign]').forEach(sign);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
